import Vue from 'vue'
import { message, Spin } from 'ant-design-vue'

Vue.prototype.$message = message

Vue.use(Spin)
